function getFacetOptionLabel(facet, itemLabel, intl) {
  const options = facet.options && facet.options[itemLabel.toLowerCase()];
  const labelFromOptions = options && (options.labelKey ? intl.getLabel(options.labelKey) : options.label);
  return {
    icon: options && options.icon,
    label: labelFromOptions || itemLabel
  };
}
export {
  getFacetOptionLabel
};
//# sourceMappingURL=get-facet-option-label.js.map
